import React, { useState } from 'react';

// import components
import Logo from '../assets/img/logo1.png';
import Nav from './Nav';

import { Link } from 'react-router-dom';
import { Box, Button, Drawer, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { navigationData } from '../data';


const Header = () => {
  const [navMobile, setNavMobile] = useState(false);
  const [state,setState]=useState({
    left:false
  })
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };
  const list = (anchor) => (
    
    <Box
    className='pt-4 pl-4 '
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      
      <List>
     
     {navigationData.map((item, index) => {
        return (
          <ListItem key={index}>
            <ListItemButton>
            <a  href={item.href}>
            <ListItemText primary={item.name}/>
            </a>
             
            </ListItemButton>
          </ListItem>
        );
      })}
     
      </List>
    </Box>
  );
  return (
    <header
      className=' sticky top-0 mb-12 lg:mb-0 z-20  px-4 lg:px-0'
      data-aos='fade-down'
      data-aos-delay='1200'
      data-aos-duration='1000'
    >
    <div className='flex items-center mr-3
    '>
    <div className=' flex w-[100vw] justify-between ' >
    {/* logo */}
    
         <Link to='/'>
            <img style={{maxWidth:"60%"}} src={Logo} alt='logo' />
          </Link>
          <div className='hidden lg:flex lg: mr-20'>
            <Nav />
          </div>
          
    </div>
       {/* mobile nav / initially is showing / hide on large screens */}
       <div
         
        >
    
          <Drawer
        anchor="left"
        open={state["left"]}
        onClose={toggleDrawer("left", false)}
      >
        {list("left")}
      </Drawer>
        </div>

     

        {/* nav trigger btn / only shows on mobile screens */}
        <div
          onClick={() => setNavMobile(!navMobile)}
          className='text-2xl text-primary cursor-pointer lg:hidden'
        >
          
          <Button  onClick={toggleDrawer("left", true)}><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
  <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5" />
</svg>
</Button>
        </div>
        
    </div>
     
    </header>
  );
};

export default Header;
